const pdpHelpers = require('./pdpHelpers');
let repeatRecipe = '';
const isFlowStoreSubscription  = $("input[name='isFlowStoreSubscription']").data('flow-store-subscription');
const BOTH_EYES_PLAN = 'bothEyesPlans';
const RIGHT_EYE = 'right';
const LEFT_EYE = 'left';

function copyFromTo(from, to) {
    const fromValue = $(from).val();
    $(to).val(fromValue);
}

$(document).on('click', '.configure-btn', function(){
    const target = $('.carga-receta-pdp-title');
    if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top - 150
        }, 500);
        $(".upload-your-recipe-title").addClass("scroll-focused");
        $(".tabs-suscripcion").addClass("scroll-focused");
    }
})

$('#repite-receta-accordion').bind('shown.bs.collapse', function () {
    repeatRecipe = 'repite-receta-accordion';
});

$('#repite-receta-accordion2').bind('shown.bs.collapse', function () {
    repeatRecipe = false;
});

function validationPlanSelects(shouldDisableButton) {
    if (!shouldDisableButton &&
        (!$('#subscriptionPlansSelect').val() || $('#subscriptionPlansSelect').val() === 'default')) {
        shouldDisableButton = true;
    }
    selectedNotificationError();
    return shouldDisableButton;
}

function flowStoreValidations(shouldDisableButton) {
    if (isFlowStoreSubscription && !shouldDisableButton) {
        repeatRecipe === 'repite-receta-accordion' ? true : false;
        let hasResults = $('#resultadosReceta .resultado-receta-pdp').length  > 0 ? true : false;
        if (repeatRecipe && !hasResults) {
            shouldDisableButton = true;
        } else {
            if (!repeatRecipe && validationSelectsEmpty()) {
                shouldDisableButton = true;
            }
        }
    }
    return shouldDisableButton;
}

function isSubscription() {
    const currentFormSelector = pdpHelpers.resolveActiveTabSelector();
    const isSubscriptionElement = $(currentFormSelector + " [data-is-subscription]");
    let isSubscription = false;
    if (isSubscriptionElement.length > 0) {
        isSubscription = !!isSubscriptionElement.val();
    }

    return isSubscription;
}


function validationSelectsEmpty() {
    let selectorEye = $('input:radio[name=step1]:checked').val();
    let bothEyesPlanSelector = 'div.subscription-pdp form.configLensForm select.item-selector';
    let formSelects;
    const SELECT_OPTION = 'Selecciona';
    let isEmpty = false;

    if (selectorEye === BOTH_EYES_PLAN) {
        formSelects = bothEyesPlanSelector;
    } else {
        const selectedEyeValue = $('.step1dot1 .step1-options input:checked').val();

        if (!selectedEyeValue) {
            return true;
        }

        let singleEyePlanSelector = 'div.subscription-pdp form.configLensForm .' + selectedEyeValue + '-eye select.item-selector';
        formSelects = singleEyePlanSelector;
    }

    for (let i = 0; i < $(formSelects).length; i++) {
        if ($(formSelects)[i].value === SELECT_OPTION) {
            isEmpty = true;
            break;
        }
    }

    return isEmpty;
}


function validationSelectsEmptyInModal() {
    let formSelects = 'form.configLensForm .right-eye select.item-selector';
    const SELECT_OPTION = 'Selecciona';
    let isEmpty = false;
    for (let i = 0; i < $(formSelects).length; i++) {
        if ($(formSelects)[i].value === SELECT_OPTION) {
            isEmpty = true;
            break;
        }
    }

    return isEmpty;
}

function isValidLens(check, str, curve, dia, axis, add, cyl) {
    if (check == true && str !== null && curve !== null && dia !== null) {
        return (
            (axis === undefined && add === undefined && cyl === undefined) || //If doesn't have axis, add and cylinder
            (axis === undefined && !!(cyl || add)) || //or if doesn't have axis and has cylinder or add with value
            (add === undefined && !!(axis || cyl)) || //or if doesn't have add and has axis or cylinder with value
            (cyl === undefined && !!(add || axis))
        ); //or if doesn't have cylinder and has add or axis with value
    }
    return false;
}

function erroQty (isRecipe) {
    let error= false;
    let qtyLeft = $('.receta-quant-left-eye').val();
    let isFlowStore = $('[data-flow-store-subscription]') ? $('[data-flow-store-subscription]').data('flow-store-subscription') : false;
    let qtyRight = $('.receta-quant-right-eye').val();
    let tipoProducto = $("[data-tipo-producto]").val();

    if (tipoProducto === "lenteContacto") {
        if (!isFlowStore && Number(qtyLeft) === 0 && Number(qtyRight) === 0 && !$('.tab-subscription-pdp.active').length > 0) {
            error = true;
            if(isRecipe){
                $('.quant-input').addClass('error-quantity');
            }
        } else {
            $('.quant-input').removeClass('error-quantity');
        }
    }
    return error;
}

function igualar() {
    copyFromTo(".selecciona-sph-left", ".selecciona-sph-right");
    copyFromTo(".selecciona-cyl-left", ".selecciona-cyl-right");
    copyFromTo(".selecciona-axis-left", ".selecciona-axis-right");
    copyFromTo(".selecciona-dmtr-left", ".selecciona-dmtr-right");
    copyFromTo(".selecciona-crvt-left", ".selecciona-crvt-right");
    copyFromTo(".selecciona-adds-left", ".selecciona-adds-right");

    $(".receta-quant-right-eye").val($(".receta-quant-left-eye").val());
}

function verifyContactLens() {
    const currentFormSelector = pdpHelpers.resolveActiveTabSelector();
    var myRadio = $(currentFormSelector + ' input[name="diff"]');

    var checkedValue = myRadio.filter(":checked").val();
    if (checkedValue != "diferentes") {
        igualar();
    }

    var left_qty = $(currentFormSelector + " .receta-quant-left-eye").val();
    var left_check = left_qty > 0;
    var left_str = $(currentFormSelector + " .selecciona-sph-left").val();
    var left_curve = $(currentFormSelector + " .selecciona-crvt-left").val();
    var left_dia = $(currentFormSelector + " .selecciona-dmtr-left").val();
    var left_axis = $(currentFormSelector + " .selecciona-axis-left").val();
    var left_cyl = $(currentFormSelector + " .selecciona-cyl-left").val();
    var left_add = $(currentFormSelector + " .selecciona-adds-left").val();
    var right_qty = $(currentFormSelector + " .receta-quant-right-eye").val();
    var right_check = right_qty > 0;
    var right_str = $(currentFormSelector + " .selecciona-sph-right").val();
    var right_curve = $(currentFormSelector + " .selecciona-crvt-right").val();
    var right_dia = $(currentFormSelector + " .selecciona-dmtr-right").val();
    var right_axis = $(currentFormSelector + " .selecciona-axis-right").val();
    var right_cyl = $(currentFormSelector + " .selecciona-cyl-right").val();
    var right_add = $(currentFormSelector + " .selecciona-adds-right").val();

    var valid_left = isValidLens(left_check, left_str, left_curve, left_dia, left_axis, left_add, left_cyl);
    var valid_right = isValidLens(right_check, right_str, right_curve, right_dia, right_axis, right_add, right_cyl);

    if (!isSubscription()) {
        if (left_check === true || right_check === true) {
            if (valid_left === true && valid_right === true) {
                $(currentFormSelector + " .lens-deselected").addClass("d-none");
            } else if (valid_left === true && right_check === false) {
                $(currentFormSelector + " .lens-deselected").addClass("d-none");
            } else if (valid_right === true && left_check === false) {
                $(currentFormSelector + " .lens-deselected").addClass("d-none");
            } else {
                $(currentFormSelector + " .lens-deselected").removeClass("d-none");
            }
        } else {
            $(currentFormSelector + " .lens-deselected").removeClass("d-none");
        }
    }

    canBeAddedToCart();
}

function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
}

function formatDate(date) {
    return (
        [
            date.getFullYear(),
            padTo2Digits(date.getMonth() + 1),
            padTo2Digits(date.getDate()),
        ].join("-") +
        "_" +
        [
            padTo2Digits(date.getHours()),
            padTo2Digits(date.getMinutes()),
            padTo2Digits(date.getSeconds()),
        ].join("-")
    );
}

function returnValueElements(array) {
    var returnArray = [];

    for (var key in array) {
        returnArray[key] = parseFloat(array[key].value);
    }
    return returnArray;
}

function removeDomElements(type, clone, params) {
    var cantLeftEye = clone.querySelectorAll(".consulta-quant-left-eye");
    var cantRightEye = clone.querySelectorAll(".consulta-quant-right-eye");
    var resultadoReceta = clone.querySelectorAll(".resultado-receta-pdp");
    var tusDatos = clone.querySelectorAll(".busca-receta-tus-datos");
    var cantUltReceta = clone.querySelectorAll(".cantidad-ultima-receta");

    function removeCommon() {
        if (resultadoReceta.length > 0) {
            clone.querySelector(".resultado-receta-pdp").remove();
        }
        if (tusDatos.length > 0) {
            clone.querySelector(".busca-receta-tus-datos").remove();
        }
    }

    function removeLeft() {
        if (cantLeftEye.length > 0) {
            clone.querySelector(".consulta-quant-left-eye").closest('.selects').remove();
        }
    }

    function removeRight() {
        if (cantRightEye.length > 0) {
            clone.querySelector(".consulta-quant-right-eye").closest('.selects').remove();
        }
    }

    function removeAll() {
        removeLeft();
        removeRight();
        removeCommon();
        if (cantUltReceta.length > 0) {
            clone.querySelector(".cantidad-ultima-receta").remove();
        }
    }

    let msg = $('#recetaRut').data('messages');

    switch (type) {
        case "all":
            toggleError(msg.all, true);
            removeAll();
            break;
        case "left":
            toggleError(msg.left, true);
            removeLeft();
            removeCommon();
            break;
        case "right":
            toggleError(msg.right, true);
            removeRight();
            removeCommon();
            break;
        case "params":
            if (params.rightEyeSku && params.leftEyeSku) {
                if (params.consultaDer == undefined && params.consultaIzq == undefined) {
                    toggleError(msg.all, true);
                    removeAll();
                }
            } else if (params.rightEyeSku) {
                if (params.consultaDer == undefined) {
                    toggleError(msg.right, true);
                    removeRight();
                    removeCommon();
                }
            } else if (params.leftEyeSku) {
                if (params.consultaIzq == undefined) {
                    toggleError(msg.left, true);
                    removeLeft();
                    removeCommon();
                }
            }
            break;
        default:
            break;
    }
}

function toggleError(msg, hide) {
    var messageInfoLentes = $('.busca-receta-input').siblings('.invalid-feedback');
    $('.busca-receta-input #recetaRut').css("border-color", hide ? "#c00" : "#8f8f8f");

    if (hide) {
      messageInfoLentes.text(msg);
      messageInfoLentes.show();
    } else {
      messageInfoLentes.hide();
    }
}

function putDataInTemplate(datos, template, key) {
    const currentFormSelector = pdpHelpers.resolveActiveTabSelector();

    var clone = template.content.cloneNode(true);
    var containerResults = $("#resultadosReceta");
    var tipoProducto = $("[data-tipo-producto]").val();
    let msg = $('#recetaRut').data('messages');

    if (datos.resultado == "NO ENCONTRADO") {
        toggleError(msg.noFind, true);
        clone.querySelector(".busca-receta-tus-datos").remove();

        if (tipoProducto == "lenteContacto") {
            clone.querySelector(".resultado-receta-pdp").remove();
            clone.querySelector(".cantidad-ultima-receta") ? clone.querySelector(".cantidad-ultima-receta").remove() : null;
        } else {
            clone.querySelector(".results").remove();
        }
    } else if (datos.resultado == "NO HAY RESPUESTA") {
        toggleError(msg.noResponse, true);
        clone.querySelector(".busca-receta-tus-datos").remove();

        if (tipoProducto == "lenteContacto") {
            clone.querySelector(".resultado-receta-pdp").remove();
            clone.querySelector(".cantidad-ultima-receta") ? clone.querySelector(".cantidad-ultima-receta").remove() : null;
        } else {
            clone.querySelector(".results").remove();
        }
    } else if (datos.resultado == "NO EXISTE DOCUMENTO") {
        if (tipoProducto != 'lenteContacto') {
            clone.querySelector(".busca-tu-receta-atributos").remove();
        }

        toggleError(msg.noExist, true);

        clone.querySelector(".busca-receta-tus-datos").remove();

        if (tipoProducto == "lenteContacto") {
            clone.querySelector(".resultado-receta-pdp").remove();
            clone.querySelector(".cantidad-ultima-receta") ? clone.querySelector(".cantidad-ultima-receta").remove() : null;
        } else {
            clone.querySelector(".results").remove();
        }
    } else {
        if (tipoProducto == "lenteContacto") {
            var pid = $('.product-detail:not(".bundle-item")').data("pid");
            var pidComparison = pid.slice(0, 4);
            var productCyl = $(currentFormSelector + " .selecciona-cyl-left, " + currentFormSelector + " .selecciona-cyl-right");
            var productAdd = $(currentFormSelector + " .selecciona-adds-left, " + currentFormSelector + " .selecciona-adds-right");
            var productSph = $(currentFormSelector + " .selecciona-sph-left, " + currentFormSelector + " .selecciona-sph-right");
            var productCrv = $(currentFormSelector + " .selecciona-crvt-left, " + currentFormSelector + " .selecciona-crvt-right");
            var productAxis = $(currentFormSelector + " .selecciona-axis-left, " + currentFormSelector + " .selecciona-axis-right");

            const [comparisonLeftEyeSku, comparisonrightEyeSku] = getEyeSku(datos);

            clone.querySelector(".cto-receta-dni").textContent = datos.s_doc_identidad;
            clone.querySelector(".cto-receta-date").textContent = datos.d_atencion;
            clone.querySelector(".cto-tipo-receta-resultado").textContent = datos.c_tipo_documento;
            clone.querySelector(".cto-cy_right").textContent = datos.DER_CILINDRO_LC / 100;
            clone.querySelector(".cto-cy_left").textContent = datos.IZQ_CILINDRO_LC / 100;
            clone.querySelector(".cto-ax_right").textContent = datos.DER_EJE_LEJOS;
            clone.querySelector(".cto-ax_left").textContent = datos.IZQ_EJE_LEJOS;
            clone.querySelector(".cto-sph-left").textContent = datos.IZQ_Poder_SPH.replace(",", ".");
            clone.querySelector(".cto-sph-right").textContent = datos.DER_Poder_SPH.replace(",", ".");
            clone.querySelector(".add-left").textContent = Math.abs(datos.ADD_izq / 100);
            clone.querySelector(".add-right").textContent = Math.abs(datos.ADD_der / 100);
            clone.querySelector(".dmtr-left").textContent = datos.IZQ_DIAMETRO_LC / 10;
            clone.querySelector(".dmtr-right").textContent = datos.DER_DIAMETRO_LC / 10;
            clone.querySelector(".crvt-left").textContent = datos.IZQ_CURVA_BASE_LC / 100;
            clone.querySelector(".crvt-right").textContent = datos.DER_CURVA_BASE_LC / 100;
            const params = {
                leftEyeSku: comparisonLeftEyeSku,
                rightEyeSku: comparisonrightEyeSku,
            };

            if (validateEyeSelectionAndPrescription(params)) {

                if (pidComparison != comparisonrightEyeSku && pidComparison != comparisonLeftEyeSku) {
                    removeDomElements("all", clone);
                } else if (pidComparison != comparisonrightEyeSku) {
                    removeDomElements("right", clone);
                } else if (pidComparison != comparisonLeftEyeSku) {
                    removeDomElements("left", clone);
                }

                if (pidComparison == comparisonrightEyeSku || pidComparison == comparisonLeftEyeSku ) {
                    if (productCyl.length > 0) {
                        var valuesCyl = returnValueElements([...productCyl[0]]);
                        var recetaCylDer = datos.DER_CILINDRO_LC / 100;
                        var recetaCylIzq = datos.IZQ_CILINDRO_LC / 100;
                        params.consultaDer = valuesCyl.find( (element) => element == recetaCylDer );
                        params.consultaIzq = valuesCyl.find( (element) => element == recetaCylIzq );
                        params.consultaType = "cilindro";
                        removeDomElements("params", clone, params);
                    }
                    if (productAdd.length > 0) {
                        var valuesAdd = returnValueElements([...productAdd[0]]);
                        var recetaAddIzq = Math.abs(datos.ADD_izq / 100);
                        var recetaAddDer = Math.abs(datos.ADD_der / 100);
                        params.consultaDer = valuesAdd.find( (element) => element == recetaAddIzq.toString() );
                        params.consultaIzq  = valuesAdd.find( (element) => element == recetaAddDer.toString() );
                        params.consultaType = "ADD";
                        removeDomElements("params", clone, params);
                    }
                    if (productSph.length > 0) {
                        var valuesSph = returnValueElements([...productSph[0]]);
                        var recetaSphIzq = datos.IZQ_Poder_SPH.replace(",",".");
                        var recetaSphDer = datos.DER_Poder_SPH.replace(",",".");
                        var consultaDer = valuesSph.find( (element) => element == recetaSphDer );
                        var consultaIzq = valuesSph.find( (element) => element == recetaSphIzq );
                        params.consultaDer = consultaDer;
                        params.consultaIzq = consultaIzq;
                        params.consultaType = "esfera";
                        removeDomElements("params", clone, params);
                    }
                    if (productCrv.length > 0) {
                        var valuesCrv = returnValueElements([...productCrv[0]]);
                        var recetaCurvaDer = datos.DER_CURVA_BASE_LC / 100;
                        var recetaCurvaIzq = datos.IZQ_CURVA_BASE_LC / 100;
                        var consultaDer = valuesCrv.find( (element) => element == recetaCurvaDer );
                        var consultaIzq = valuesCrv.find( (element) => element == recetaCurvaIzq );
                        params.consultaDer = consultaDer;
                        params.consultaIzq = consultaIzq;
                        params.consultaType = "curvatura";
                        removeDomElements("params", clone, params);
                    }
                    if (productAxis.length > 0) {
                        var valuesAxis = returnValueElements([...productAxis[0]]);
                        var recetaAxisDer = +datos.DER_EJE_LEJOS;
                        var recetaAxisIzq = +datos.IZQ_EJE_LEJOS;
                        var consultaDer = valuesAxis.find( (element) => element == recetaAxisDer );
                        var consultaIzq = valuesAxis.find( (element) => element == recetaAxisIzq );
                        params.consultaDer = consultaDer;
                        params.consultaIzq = consultaIzq;
                        params.consultaType = "eje";
                        removeDomElements("params", clone, params);
                    }
                }
            } else {
                var complement = key ? key : "";
                clone.querySelectorAll(".receta-dni").forEach((el) => (el.textContent = datos.s_doc_identidad));
                clone.querySelectorAll(".receta-date").forEach((el) => (el.textContent = datos.d_atencion));
                clone.querySelectorAll(".tipo-receta-resultado").forEach((el) => (el.textContent = datos.c_tipo_documento));
                clone.querySelectorAll(".sph_right").forEach((el) => (el.textContent = datos.n_dere_esferico));
                clone.querySelectorAll(".sph_left").forEach((el) => (el.textContent = datos.n_izqu_esferico));
                clone.querySelectorAll(".cy_right").forEach((el) => (el.textContent = datos.n_dere_cilindro));
                clone.querySelectorAll(".cy_left").forEach((el) => (el.textContent = datos.n_izqu_cilindro));
                clone.querySelectorAll(".ax_right").forEach((el) => (el.textContent = datos.n_dere_eje));
                clone.querySelectorAll(".ax_left").forEach((el) => (el.textContent = datos.n_izqu_eje));
                clone.querySelectorAll(".d-pup").forEach((el) => (el.textContent = datos.n_dip));
                clone.querySelector("[data-receta-completa]").setAttribute("data-receta-completa" + complement, "");

                if (key) {
                    var cloneAddToCart = document.querySelector(".add-cart-btn-container .add-to-cart-ryk").cloneNode(true);
                    cloneAddToCart.setAttribute("data-use","data-receta-completa" + key);
                    cloneAddToCart.textContent = "Agregar al carro esta fórmula";
                    cloneAddToCart.classList.add("mx-auto");
                    cloneAddToCart.classList.add("mt-2");
                    clone.appendChild(cloneAddToCart);
                    $(".add-cart-btn-container").addClass("d-none");
                }
            }
        } else {
            var complement = key ? key : "";
            clone.querySelectorAll(".receta-dni").forEach((el) => (el.textContent = datos.s_doc_identidad));
            clone.querySelectorAll(".receta-date").forEach((el) => (el.textContent = datos.d_atencion));
            clone.querySelectorAll(".tipo-receta-resultado").forEach((el) => (el.textContent = datos.c_tipo_documento));
            clone.querySelectorAll(".sph_right").forEach((el) => (el.textContent = datos.n_dere_esferico));
            clone.querySelectorAll(".sph_left").forEach((el) => (el.textContent = datos.n_izqu_esferico));
            clone.querySelectorAll(".cy_right").forEach((el) => (el.textContent = datos.n_dere_cilindro));
            clone.querySelectorAll(".cy_left").forEach((el) => (el.textContent = datos.n_izqu_cilindro));
            clone.querySelectorAll(".ax_right").forEach((el) => (el.textContent = datos.n_dere_eje));
            clone.querySelectorAll(".ax_left").forEach((el) => (el.textContent = datos.n_izqu_eje));
            clone.querySelectorAll(".d-pup").forEach((el) => (el.textContent = datos.n_dip));
            clone.querySelector("[data-receta-completa]").setAttribute("data-receta-completa" + complement, "");

            if (key) {
                var cloneAddToCart = document.querySelector(".add-cart-btn-container .add-to-cart-ryk").cloneNode(true);
                cloneAddToCart.setAttribute("data-use","data-receta-completa" + key);
                cloneAddToCart.textContent = "Agregar al carro esta fórmula";
                cloneAddToCart.classList.add("mx-auto");
                cloneAddToCart.classList.add("mt-2");
                clone.appendChild(cloneAddToCart);
                $(".add-cart-btn-container").addClass("d-none");
            }
        }

        clone.querySelector("[data-receta-completa]").setAttribute("data-receta-completa", JSON.stringify(datos));

        if (tipoProducto == "lenteContacto") {
            var leftEyeSku = datos.IZQ_SKU_POS_LC;
            var rightEyeSku = datos.DER_SKU_POS_LC;

            if (!leftEyeSku && !rightEyeSku) {
                clone.querySelector("[data-receta-completa]").setAttribute("data-receta-completa", "");
            }
        }

        if (clone.querySelector(".busca-receta-tus-datos")) {
            $('.receta-accordion-form.ajaxCargaReceta').hide();
        }

        containerResults[0].appendChild(clone);

        if (!$("#rombos").hasClass("d-flex")) {
            $("#rombos").removeClass("d-none").addClass("d-flex");
        }

        validatePrescriptionAndSelectedEye(datos, clone);
    }
}

/**
 * Gets sku data for each eye side
 * @param {object} datos
 * @returns {object}
 */
function getEyeSku(datos) {
    var leftEyeSku = datos.IZQ_SKU_POS_LC;
    var rightEyeSku = datos.DER_SKU_POS_LC;
    var comparisonLeftEyeSku = leftEyeSku ? leftEyeSku.slice(0, 4) : '';
    var comparisonrightEyeSku = rightEyeSku ? rightEyeSku.slice(0, 4) : '';
    return [
        comparisonLeftEyeSku,
        comparisonrightEyeSku
    ]
}

/**
 * Validates selected eye based on the prescription
 *
 * @param {object} datos
 * @param {object} clone
 * @returns {void}
 */
function validatePrescriptionAndSelectedEye(datos, clone) {
    const [comparisonLeftEyeSku, comparisonrightEyeSku] = getEyeSku(datos);

    const hastLeftEyeSku = comparisonLeftEyeSku != "" && comparisonLeftEyeSku != undefined && comparisonLeftEyeSku != null;
    const hastRightEyeSku =  comparisonrightEyeSku != "" && comparisonrightEyeSku != undefined && comparisonrightEyeSku != null;

    const isValid = validateEyeSelectionAndPrescription({
        leftEyeSku: comparisonLeftEyeSku,
        rightEyeSku: comparisonrightEyeSku
    });

    if (isValid) {
        $(".add-to-cart-ryk").prop("disabled", true);
        return;
    }

    switch (getSelectedEyeRecipeRows()) {
        case BOTH_EYES_PLAN :
            // Show repeat prescription messjage if applies
            if (!hastLeftEyeSku || !hastRightEyeSku) {
                const prescriptionEyeSelectedWarning = $('.message-prescription-eye-selected-warning');

                $(prescriptionEyeSelectedWarning).removeClass('d-none');
                $(prescriptionEyeSelectedWarning).find('.repeat-prescription').removeClass('d-none');
            }
            break;
        default:

            let selectedQuantityEyes = $("input:radio[name='step1.1']:checked").val();
            if (!hastLeftEyeSku && selectedQuantityEyes === LEFT_EYE) {
                const prescriptionEyeSelectedWarning = $('.message-prescription-eye-selected-warning');

                $(prescriptionEyeSelectedWarning).removeClass('d-none');
                $(prescriptionEyeSelectedWarning).find('.only-right-eye').removeClass('d-none');
            }

            if (!hastRightEyeSku && selectedQuantityEyes === RIGHT_EYE) {
                const prescriptionEyeSelectedWarning = $('.message-prescription-eye-selected-warning');

                $(prescriptionEyeSelectedWarning).removeClass('d-none');
                $(prescriptionEyeSelectedWarning).find('.only-left-eye').removeClass('d-none');
            }

            if (hastRightEyeSku && hastLeftEyeSku) {
                if (selectedQuantityEyes === RIGHT_EYE) {
                    $('.resultado-receta-pdp .izq').remove();
                }

                if (selectedQuantityEyes === LEFT_EYE) {
                    $('.resultado-receta-pdp .der').remove();
                }
            }
            break;
    }

    if (!hastRightEyeSku) {
        $('.resultado-receta-pdp .der').remove();
    }

    if (!hastLeftEyeSku) {
        $('.resultado-receta-pdp .izq').remove();
    }

    $('.resultado-busqueda-receta').show();

}

/**
 * Validates the eye selection based on the prescription data
 * @param {*} data Prescription Data
 * @returns {boolean}
 */
function validateEyeSelectionAndPrescription(data) {
    const comparisonLeftEyeSku = data.leftEyeSku;
    const comparisonrightEyeSku = data.rightEyeSku;
    let validationResult = false;
    // Use Last prescription, user can use the last prescription even if the product sku does not match
    validationResult = (comparisonLeftEyeSku != "" && comparisonLeftEyeSku != undefined && comparisonLeftEyeSku != null) || (comparisonrightEyeSku != "" && comparisonrightEyeSku != undefined && comparisonrightEyeSku != null);

    return !validationResult;
}

/**
 * selectedNotificationError show error notification in select plans
 * @returns {boolean}
 */
function selectedNotificationError () {
    const selectEmpty = !$('#subscriptionPlansSelect').val() || $('#subscriptionPlansSelect').val() === 'default';
    const extraValidation = $(".file-carga-receta").is(':visible') ? $("#subscriptionRecipeUrl").val().length > 0 : $('#repite-receta-accordion').hasClass('show');
    if (selectEmpty && pdpHelpers.isTabSuscriptionActive() && extraValidation) {
        $('.step-select-error-message').removeClass('d-none');
        $('#start-date-subscription-container div.container-select-subscription-plan').addClass('invalid-select');
        window.scroll(0, $('#nav-subscription-tab').offset().top);
        return true;
    } else {
        $('.step-select-error-message').addClass('d-none');
        $('#start-date-subscription-container div.container-select-subscription-plan').removeClass('invalid-select');
        return false;
    }
    
}

function lensValidations(dataUrlReceta, dataRecetaCompleta) {
    const isSubscriptionActive = $('.tab-subscription-pdp.active').length > 0;
    let shouldDisableButton = false;
    if (isSubscriptionActive) {
        let recipeValue = $(".file-carga-receta").is(':visible') ? $("#subscriptionRecipeUrl").val().length > 0 : null;
        if (recipeValue || $('#repite-receta-accordion').hasClass('show')) {
            shouldDisableButton = !pdpHelpers.validateSubscriptionEyeSelection();
            if (!shouldDisableButton) {
                shouldDisableButton = !pdpHelpers.validateOnEyeEyeSelection();
            }
        }
        
        if (!shouldDisableButton) {
            shouldDisableButton = selectedNotificationError();
        }
        
        const isRepeatRecipe = $('.subscription-pdp .repite-receta-button').attr('aria-expanded') === 'true';
        const isSpecifyRecipe = $('.subscription-pdp #repite-receta-accordion2-header').attr('aria-expanded') === 'true';

        if (!shouldDisableButton && !isRepeatRecipe && !isSpecifyRecipe) {
            shouldDisableButton = true;
        }

        shouldDisableButton = validationPlanSelects(shouldDisableButton);
        const hasPrescriptionDivEnabled = $('.resultado-busqueda-receta:visible').length;
        if (!shouldDisableButton && isRepeatRecipe && (!dataRecetaCompleta || hasPrescriptionDivEnabled === 0)) {
            shouldDisableButton = true;
        }

        if (!shouldDisableButton && isSpecifyRecipe && !dataUrlReceta && !isFlowStoreSubscription) {
            shouldDisableButton = true;
        }

        shouldDisableButton = flowStoreValidations(shouldDisableButton);

    } else {
        if (!dataUrlReceta && !dataRecetaCompleta) {
            shouldDisableButton = true;
        } else {
            erroQty(true);
        }
    }

    return shouldDisableButton;
}
function isMobile() {
    return window.innerWidth <= 768;
}

function handleConfigureBtn(shouldDisableButton) {
    if(isMobile()) {
        const configureBtn = $(".configure-btn");
        if(configureBtn.length > 0) {
            if (shouldDisableButton) {
                $(".add-to-cart-ryk").hide();
                configureBtn.show();
            } else {
                $(".add-to-cart-ryk").show();
                configureBtn.hide();
                $(".upload-your-recipe-title").removeClass("scroll-focused");
                $(".tabs-suscripcion").removeClass("scroll-focused");
            }
        }
    }
}

function canBeAddedToCart() {
    const currentFormSelector = pdpHelpers.resolveActiveTabSelector();

    let shouldDisableButton = false;

    let productType = $("[data-tipo-producto]").val();

    if (!productType || (productType && productType === 'null')) {
        productType = $(currentFormSelector + ' [data-tipo-producto]').val();
    }

    let dataUrlReceta = $(currentFormSelector + " [data-url-receta]").val();
    let dataRecetaCompleta = $("[data-receta-completa]").data("receta-completa") || $(currentFormSelector + " [data-receta-completa]").data("receta-completa");
    let dataPupillarDistance = $('[data-pupillar-distance]').val() ||  $(currentFormSelector + ' [data-pupillar-distance]').val();

    if (productType === "lenteContacto") {
        shouldDisableButton = lensValidations(dataUrlReceta, dataRecetaCompleta);
        let currentForm = $(currentFormSelector);
        if (currentForm && currentForm.data('lineitem-uuid')) {
            if(isFlowStoreSubscription){
                shouldDisableButton = validationSelectsEmptyInModal();
            }
        }
    }

    if (productType === "sol" || productType === "optica") {
        const pupillarDistanceMax = parseInt($('[data-pupillar-distance]').attr('max'));
        const pupillarDistanceMin = parseInt($('[data-pupillar-distance]').attr('min'));

        if (!dataRecetaCompleta && (!dataUrlReceta || dataPupillarDistance.length == 0)) {
            shouldDisableButton = true;
        }

        const dataPupillarDistanceInvalidFeedback = $('[data-pupillar-distance]').parent().find('.invalid-feedback');
        dataPupillarDistanceInvalidFeedback.hide();
        if (parseInt(dataPupillarDistance) < pupillarDistanceMin || parseInt(dataPupillarDistance) > pupillarDistanceMax) {
            dataPupillarDistanceInvalidFeedback.html($('[data-pupillar-distance]').data('range-error'));
            dataPupillarDistanceInvalidFeedback.show();
            shouldDisableButton = true;
        }

        if (dataPupillarDistance.length == 0) {
            dataPupillarDistanceInvalidFeedback.html($('[data-pupillar-distance]').data('error'));
            dataPupillarDistanceInvalidFeedback.show();
        }

        $(currentFormSelector + ' .cristales-file').parent().find('.invalid-feedback').hide();

        if (!dataUrlReceta) {
            $(currentFormSelector + ' .cristales-file').parent().find('.invalid-feedback').html($(currentFormSelector + ' .cristales-file').data('error'));
            $(currentFormSelector + ' .cristales-file').parent().find('.invalid-feedback').show();
        }
    }

    if($(".addToCart-sol .add-to-cart-ryk").length > 0 && $('#switch-to-cristales:checked').length === 0) {
        shouldDisableButton = false;
    }

    if(erroQty()) {
        shouldDisableButton = true;
    }

    let confirmbutton = $(currentFormSelector + " .add-to-cart-ryk");

    if(confirmbutton.length > 0) {
        confirmbutton.prop("disabled", shouldDisableButton);
    } else {
        $(".add-to-cart-ryk").prop("disabled", shouldDisableButton);
        handleConfigureBtn(shouldDisableButton);
    }

    if(isSubscription()) {
        $(currentFormSelector + " .btn.confirm").prop("disabled", shouldDisableButton);
    }

    // Solo aplicar validación de invalid-feedback para productos Sol y Ópticos
    if (productType === "sol" || productType === "optica") {
        if ($('.invalid-feedback').is(":visible")) {
            shouldDisableButton = true;
            $(".add-to-cart-ryk").prop("disabled", shouldDisableButton);
            handleConfigureBtn(shouldDisableButton);
        }
    }

    return !shouldDisableButton;
}

function checkIfUnique(selector, id) {
    $.each($(selector), function () {
        if ($(this).attr("id") != id) {
            $(this).prop("checked", false);
        }
    });
}

function fillAttributesInColor(parent, colorAtributes) {
    var dataColorAttributes = $("[data-adicionales]").data("color-attributes");
    var templateColorAttributes = document.querySelector("#adds_attributes");
    var colorAttributesFiltered = [];
    var counter = 0;

    // Ensure dataColorAttributes is an array
    if (!Array.isArray(dataColorAttributes)) {
        dataColorAttributes = [];
    }

    for (activity in colorAtributes) {
        var attribute = Object.keys(colorAtributes)[counter];
        var currentAttributesValue = dataColorAttributes.filter(
            (element) => element.id == attribute
        );
        if (currentAttributesValue[0]) {
            colorAttributesFiltered.push(currentAttributesValue[0]);
        }
        counter++;
    }

    for (var key in colorAttributesFiltered) {
        var element = colorAttributesFiltered[key];
        if (!element) continue; // Skip if element is undefined
        
        var contentColorAttributes =templateColorAttributes.content.cloneNode(true);
        var src = contentColorAttributes.querySelector(".separator-svg").src;
        
        // Handle missing icon property
        if (element.icon) {
            src = src + element.icon;
        }
        
        contentColorAttributes.querySelector(".separator-svg").setAttribute("src", src);
        contentColorAttributes.querySelector(".separator-svg").setAttribute("alt", element.name || '');
        contentColorAttributes.querySelector(".extra-subtext").textContent = element.name || '';
        parent.appendChild(contentColorAttributes);
    }
}

function fillSolarOpticColorsSimple(parent, $this, dataColors, solarColors, packName, parentName) {
    console.log('fillSolarOpticColorsSimple called for pack:', packName, 'treatment:', parentName);
    
    // Get treatment configuration
    var packagesConfig = $('body').data('selected-package-config');
    var colorsConfig = $('body').data('colors-config');
    
    if (!packagesConfig || !colorsConfig) {
        console.log('Missing package or colors config');
        return;
    }
    
    // Find the treatment configuration
    var treatmentConfig = null;
    for (var packageKey in packagesConfig.treatments) {
        if (packagesConfig.treatments[packageKey].id === $this.data("adds-extra").Id) {
            treatmentConfig = packagesConfig.treatments[packageKey];
            break;
        }
    }
    
    if (!treatmentConfig) {
        console.log('Treatment config not found');
        return;
    }
    
    console.log('Treatment config found:', treatmentConfig);
    
    // Clear existing options
    parent.empty();
    
    if (treatmentConfig.types) {
        // Handle treatments with types (like Teñido with Sólido/Degradé)
        console.log('Treatment has types:', treatmentConfig.types);
        
        for (var typeKey in treatmentConfig.types) {
            var type = treatmentConfig.types[typeKey];
            console.log('Processing type:', typeKey, type);
            
            // Create type toggle using existing template
            var typeTemplate = document.querySelector("#adds-extra-bronce-template");
            if (isMobile()) {
                typeTemplate = document.querySelector("#adds-extra-bronce-template-mobile");
            }
            
            if (typeTemplate) {
                var $typeTemplate = $(typeTemplate.content.cloneNode(true));
                
                $typeTemplate.find('.title').text(type.name);
                $typeTemplate.find('.description').text(getTypeDescription(typeKey));
                $typeTemplate.find('.checkbox').attr('id', 'type_' + typeKey);
                $typeTemplate.find('.checkbox').attr('data-type-id', typeKey);
                $typeTemplate.find('.checkbox').attr('data-displayname', type.name);
                $typeTemplate.find('.checkbox').addClass('type-switch-options');
                $typeTemplate.find('.checkbox').addClass('color-type-toggle');
                
                // Hide price for type toggles
                $typeTemplate.find('.price').hide();
                
                parent.append($typeTemplate);
                
                // Create color container for this type (initially hidden)
                var colorContainer = $('<div class="color-options-' + typeKey + '" style="display: none;"></div>');
                
                // Add colors for this type using existing template
                if (type.colors) {
                    for (var i = 0; i < type.colors.length; i++) {
                        var colorId = type.colors[i];
                        var colorConfig = colorsConfig[colorId];
                        
                        if (colorConfig) {
                            var template = document.querySelector("#adds-extra-bronce-template");
                            if (isMobile()) {
                                template = document.querySelector("#adds-extra-bronce-template-mobile");
                            }
                            
                            if (template) {
                                var $template = $(template.content.cloneNode(true));
                                
                                $template.find('.title').text(colorConfig.name);
                                $template.find('.description').text(colorConfig.description);
                                $template.find('.checkbox').attr('id', colorId + '_' + typeKey);
                                $template.find('.checkbox').attr('data-color-id', colorId);
                                $template.find('.checkbox').attr('data-labname', colorConfig.labName);
                                $template.find('.checkbox').attr('data-type-id', typeKey);
                                $template.find('.checkbox').attr('data-displayname', colorConfig.name);
                                $template.find('.checkbox').attr('data-sku', $this.data("adds-extra").Id);
                                $template.find('.checkbox').addClass('color-switch-options');
                                
                                // Add activity attributes if available
                                if (colorConfig.attributes && Array.isArray(colorConfig.attributes)) {
                                    fillAttributesInColor($template.find('.adds-extra-icons'), colorConfig.attributes);
                                }
                                
                                colorContainer.append($template);
                            }
                        }
                    }
                }
                
                parent.append(colorContainer);
            }
        }
        
        // Ensure all color containers are hidden initially
        $('.color-options-solido, .color-options-degrade').hide();
    } else if (treatmentConfig.colors) {
        // Handle treatments with direct colors (like Espejado, Polarizado)
        console.log('Treatment has direct colors:', treatmentConfig.colors);
        
        for (var i = 0; i < treatmentConfig.colors.length; i++) {
            var colorId = treatmentConfig.colors[i];
            var colorConfig = colorsConfig[colorId];
            
            if (colorConfig) {
                var template = document.querySelector("#adds-extra-bronce-template");
                if (isMobile()) {
                    template = document.querySelector("#adds-extra-bronce-template-mobile");
                }
                
                if (template) {
                    var $template = $(template.content.cloneNode(true));
                    
                    $template.find('.title').text(colorConfig.name);
                    $template.find('.description').text(colorConfig.description);
                    $template.find('.checkbox').attr('id', colorId);
                    $template.find('.checkbox').attr('data-color-id', colorId);
                    $template.find('.checkbox').attr('data-labname', colorConfig.labName);
                    $template.find('.checkbox').attr('data-displayname', colorConfig.name);
                    $template.find('.checkbox').addClass('color-switch-options');
                    
                    // Add activity attributes if available
                    if (colorConfig.attributes && Array.isArray(colorConfig.attributes)) {
                        fillAttributesInColor($template.find('.adds-extra-icons'), colorConfig.attributes);
                    }
                    
                    parent.append($template);
                }
            }
        }
    }
}

function fillSolarOpticColorsNew(parent, $this, dataColors, solarColors, packName, parentName) {
    console.log('fillSolarOpticColorsNew called for pack:', packName, 'treatment:', parentName);
    
    // Get treatment configuration
    var packagesConfig = $('body').data('selected-package-config');
    var colorsConfig = $('body').data('colors-config');
    
    if (!packagesConfig || !colorsConfig) {
        console.log('Missing package or colors config');
        return;
    }
    
    // Find the treatment configuration
    var treatmentConfig = null;
    for (var packageKey in packagesConfig.treatments) {
        if (packagesConfig.treatments[packageKey].id === $this.data("adds-extra").Id) {
            treatmentConfig = packagesConfig.treatments[packageKey];
            break;
        }
    }
    
    if (!treatmentConfig) {
        console.log('Treatment config not found');
        return;
    }
    
    console.log('Treatment config found:', treatmentConfig);
    
    // Clear existing options
    parent.empty();
    
    if (treatmentConfig.types) {
        // Handle treatments with types (like Teñido with Sólido/Degradé)
        console.log('Treatment has types:', treatmentConfig.types);
        
        for (var typeKey in treatmentConfig.types) {
            var type = treatmentConfig.types[typeKey];
            console.log('Processing type:', typeKey, type);
            
            // Create type toggle using existing template
            var typeTemplate = document.querySelector("#adds-extra-bronce-template");
            if (isMobile()) {
                typeTemplate = document.querySelector("#adds-extra-bronce-template-mobile");
            }
            
            if (typeTemplate) {
                var $typeTemplate = $(typeTemplate.content.cloneNode(true));
                
                $typeTemplate.find('.title').text(type.name);
                $typeTemplate.find('.description').text(getTypeDescription(typeKey));
                $typeTemplate.find('.checkbox').attr('id', 'type_' + typeKey);
                $typeTemplate.find('.checkbox').attr('data-type-id', typeKey);
                $typeTemplate.find('.checkbox').attr('data-displayname', type.name);
                $typeTemplate.find('.checkbox').addClass('type-switch-options');
                $typeTemplate.find('.checkbox').addClass('color-type-toggle');
                
                // Hide price for type toggles
                $typeTemplate.find('.price').hide();
                
                parent.append($typeTemplate);
                
                // Create color container for this type (initially hidden)
                var colorContainer = $('<div class="color-options-' + typeKey + '" style="display: none;"></div>');
                
                // Add colors for this type using existing template
                if (type.colors) {
                    for (var i = 0; i < type.colors.length; i++) {
                        var colorId = type.colors[i];
                        var colorConfig = colorsConfig[colorId];
                        
                        if (colorConfig) {
                            var template = document.querySelector("#adds-extra-bronce-template");
                            if (isMobile()) {
                                template = document.querySelector("#adds-extra-bronce-template-mobile");
                            }
                            
                            if (template) {
                                var $template = $(template.content.cloneNode(true));
                                
                                $template.find('.title').text(colorConfig.name);
                                $template.find('.description').text(colorConfig.description);
                                $template.find('.checkbox').attr('id', colorId + '_' + typeKey);
                                $template.find('.checkbox').attr('data-color-id', colorId);
                                $template.find('.checkbox').attr('data-labname', colorConfig.labName);
                                $template.find('.checkbox').attr('data-type-id', typeKey);
                                $template.find('.checkbox').attr('data-displayname', colorConfig.name);
                                $template.find('.checkbox').attr('data-sku', $this.data("adds-extra").Id);
                                $template.find('.checkbox').addClass('color-switch-options');
                                
                                // Add activity attributes if available
                                if (colorConfig.attributes && Array.isArray(colorConfig.attributes)) {
                                    fillAttributesInColor($template.find('.adds-extra-icons'), colorConfig.attributes);
                                }
                                
                                colorContainer.append($template);
                            }
                        }
                    }
                }
                
                parent.append(colorContainer);
            }
        }
        
        // Ensure all color containers are hidden initially
        $('.color-options-solido, .color-options-degrade').hide();
    } else if (treatmentConfig.colors) {
        // Handle treatments with direct colors (like Espejado, Polarizado)
        console.log('Treatment has direct colors:', treatmentConfig.colors);
        
        for (var i = 0; i < treatmentConfig.colors.length; i++) {
            var colorId = treatmentConfig.colors[i];
            var colorConfig = colorsConfig[colorId];
            
            if (colorConfig) {
                var template = document.querySelector("#adds-extra-bronce-template");
                if (isMobile()) {
                    template = document.querySelector("#adds-extra-bronce-template-mobile");
                }
                
                if (template) {
                    var $template = $(template.content.cloneNode(true));
                    
                    $template.find('.title').text(colorConfig.name);
                    $template.find('.description').text(colorConfig.description);
                    $template.find('.checkbox').attr('id', colorId);
                    $template.find('.checkbox').attr('data-color-id', colorId);
                    $template.find('.checkbox').attr('data-labname', colorConfig.labName);
                    $template.find('.checkbox').attr('data-displayname', colorConfig.name);
                    $template.find('.checkbox').addClass('color-switch-options');
                    
                    // Add activity attributes if available
                    if (colorConfig.attributes && Array.isArray(colorConfig.attributes)) {
                        fillAttributesInColor($template.find('.adds-extra-icons'), colorConfig.attributes);
                    }
                    
                    parent.append($template);
                }
            }
        }
    }
}

function getTypeDescription(typeKey) {
    var descriptions = {
        'solido': 'Lentes tintados a elección de manera uniforme para mejor experiencia.',
        'degrade': 'Los cristales son tintados en degradé, de manera que el color del lente se va atenuando.'
    };
    
    return descriptions[typeKey] || 'Tipo de tratamiento especializado.';
}

function fillChildColors(parent, $this) {
    var dataColors = $("[data-adicionales]").data("colores");
    var solarColors = $("[data-adicionales]").data("solar-colors");
    var data = $this.data("adds-extra");
    let colores = data.colores;
    let subColores = data.subColores;
    let packName = $("#pdp__cristales-modal .pack-column-desktop.selected").data('pack-name') && $("#pdp__cristales-modal .pack-column-desktop.selected").data('pack-name').toLowerCase();
    if (isMobile()) {
        packName = $(".mobile-cristales-grid .sol-optic-last-item.mobile-selected").data('pack-name').toLowerCase();
    }
    var parentName = data.name && data.name.toLowerCase();
    var counter = 0;
    
    // Use solar colors configuration if available
    if (solarColors && typeof solarColors === 'object') {
        dataColors = Object.values(solarColors);
    }
    
    // Ensure dataColors is an array
    if (!Array.isArray(dataColors)) {
        dataColors = [];
    }
    
    // For solar optic products, use new simplified logic
    if (packName && (packName === 'bronce' || packName === 'plata' || packName === 'oro' || packName === 'platino')) {
        fillSolarOpticColorsSimple(parent, $this, dataColors, solarColors, packName, parentName);
        return;
    }
    
    if (subColores && packName === 'bronce') {
        colores = subColores;
        $(".adds-sub-color-options").addClass('d-none');
    }
    for (var color in colores) {
        var name = Object.keys(colores)[counter];
        if (colores[color]) {
            if (!$(`.option-wrapper.${name}`).length) {
                var template = document.querySelector("#adds-extra-template");
                if (isMobile()) {
                    template = document.querySelector("#adds-extra-template-mobile");
                }
                var currentColorData = dataColors.filter(
                    (element) => element.id == color
                );
                currentColorData = currentColorData[0];
                let tooltip = currentColorData && currentColorData.tooltip && currentColorData.tooltip;
                let tooltipAddon = tooltip && currentColorData.tooltip.addon && currentColorData.tooltip.addon.toLowerCase();
                let tooltipPackName = tooltip && currentColorData.tooltip.packName && currentColorData.tooltip.packName.toLowerCase();
                if (parentName === tooltipAddon && packName === tooltipPackName) {
                    if (isMobile()) {
                        template = document.querySelector("#adds-extra-bronce-template-mobile");
                    }
                    else {
                        template = document.querySelector("#adds-extra-bronce-template");
                    }
                }
                var content = template.content.cloneNode(true);
                // Elimina todos los tooltips que no coincidan con el color
                content.querySelectorAll('.tooltip-pop-up').forEach(tooltip => {
                    if (!tooltip.classList.contains(color)) {
                        tooltip.remove();
                    }
                });
                var showName = currentColorData.name;
                var currentColorAttributes = currentColorData.attributes;
                var currentColorDescription = currentColorData.description;
                var currentColorSendId = parentName && currentColorData.labName[parentName];
                content.querySelector(".title").textContent = showName;
                content.querySelector(".description").textContent = currentColorDescription;
                let titleMsg = $this.data('title-msg');
                if (packName === 'bronce') {
                    if (subColores) {
                        // content.querySelector(".checkbox").classList.add(`adds-extra-switchs`);
                        content.querySelector(".checkbox").setAttribute("data-pack-name", packName);
                        content.querySelector(".checkbox").setAttribute("data-id", $this.attr("id"));
                        content.querySelector(".checkbox").setAttribute("data-adds-extra", JSON.stringify(data.colores));
                        content.querySelector(".checkbox").setAttribute("data-step", $('.tratamientos.continuar').attr('sol-step'));
                    }
                    
                    if (titleMsg) {
                        $('.adds-extra-options-wrapper .main-title').text(titleMsg);
                    }
                } else {
                    let titleTxt = $('.pack-column.selected').data('title');
                    titleTxt && $('.adds-extra-options-wrapper .main-title').text(titleTxt);

                }
                content.querySelector(".checkbox").id = `color-option-${name}`;
                content.querySelector(".checkbox").setAttribute("data-idsend",currentColorSendId);
                content.querySelector(".checkbox").setAttribute("data-displayname",currentColorData.id.toLowerCase());
                content
                    .querySelector(".switch")
                    .setAttribute("for", `color-option-${name}`);
                content.querySelector(".option-wrapper").classList.add(name);
                fillAttributesInColor(
                    content.querySelector(".adds-extra-icons"),
                    currentColorAttributes
                );
                if (counter == Object.keys(data.colores).length - 1) {
                    content.querySelector(".rhombus-separator-adds").remove();
                }
                parent.append(content);

                // Inicializar Slick en el carrusel recién agregado
                let $insertedWrapper = $(parent).find(`.option-wrapper.${name}`);
                let $carousel = $insertedWrapper.find('[data-customCarouselModalCristales]');
                if ($carousel.length && !$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        slidesToShow: 1,
                        infinite: true,
                        arrows: false,
                        slidesToScroll: 1,
                        dots: true,
                        adaptiveHeight: true
                    });
                }
            }
        }
        counter++;
    }
}
function fillSubChildColors(parent, $this) {
    var dataColors = $("[data-adicionales]").data("colores");
    let addonsColorName = $this.data('displayname').toLowerCase();
    let addonInfo = dataColors.find(c => c.id === addonsColorName);
    addonInfo = addonInfo && addonInfo.addonsColors;
    var colores = addonInfo ? addonInfo : $this.data("adds-extra");
    var counter = 0;
    for (var color in colores) {
        var name = Object.keys(colores)[counter];
        if (colores[color]) {
            let template = document.querySelector("#adds-extra-template");
            if (isMobile()) {
                template = document.querySelector("#adds-extra-template-mobile");
            }
            var content = template.content.cloneNode(true);
            var currentColorData = dataColors.filter(
                (element) => element.id == color
            );
            currentColorData = currentColorData[0];
            var showName = currentColorData.name;
            var currentColorAttributes = currentColorData.attributes;
            var currentColorDescription = currentColorData.description;
            content.querySelector(".title").textContent = showName;
            content.querySelector(".description").textContent = currentColorDescription;
            content.querySelector(".checkbox").id = `color-option-${name}`;
            content.querySelector(".checkbox").classList.remove("color-switch-options");
            content.querySelector(".checkbox").classList.add("adds-sub-colors");
            content.querySelector(".checkbox").setAttribute("data-displayname",currentColorData.id);
            content.querySelector(".checkbox").setAttribute("data-parent-name",addonsColorName);
            content
                .querySelector(".switch")
                .setAttribute("for", `color-option-${name}`);
            content.querySelector(".option-wrapper").classList.add(name);
            fillAttributesInColor(
                content.querySelector(".adds-extra-icons"),
                currentColorAttributes
            );
            if (counter == Object.keys(colores).length - 1) {
                content.querySelector(".rhombus-separator-adds").remove();
            }
            parent.append(content);
        }
        counter++;
    }
    let titleTxt = $('.adds-extra-options-colors .color-name');
    titleTxt.text(addonsColorName);
}

/**
 * Depending on which value of eye subcription is selected,
 * the recipe result table rows are shown/hide.
 */
function displaySelectedEyeRecipeRows() {
    const selectedEyeOptionValue = getSelectedEyeRecipeRows()

    $('.resultado-receta-pdp .izq').show();
    $('.resultado-receta-pdp .der').show();
}

function getSelectedEyeRecipeRows() {
    const selectedEyeOption = $(".step1 input[name='step1']:checked");
    return selectedEyeOption.val();
}

module.exports = {
    formatDate: formatDate,
    verifyContactLens: verifyContactLens,
    putDataInTemplate: putDataInTemplate,
    canBeAddedToCart: canBeAddedToCart,
    checkIfUnique: checkIfUnique,
    fillChildColors: fillChildColors,
    toggleError: toggleError,
    erroQty: erroQty,
    displaySelectedEyeRecipeRows: displaySelectedEyeRecipeRows,
    getSelectedEyeRecipeRows: getSelectedEyeRecipeRows,
    validationPlanSelects : validationPlanSelects,
    selectedNotificationError : selectedNotificationError,
    handleConfigureBtn : handleConfigureBtn,
    RIGHT_EYE,
    LEFT_EYE,
    fillSubChildColors: fillSubChildColors
};
